import React from "react";
import ButtonLoader from "./ButtonLoader";
import ErrorModal from "./ToastModal";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@material-ui/core";
import { Environment } from "../utils/environments";

export default function PayjpBottom({
  loading,
  handlePayjp,
  buttonClickable,
  errorModal,
  error,
  setErrorModal,
  productType,
  reserveNowParam,
  concernTextError,
  productId,
  productInfo,
}) {
  const navigate = useNavigate();
  return (
    <section style={{ paddingTop: "50px" }}>
      <div className="save-data-wrapper">
        <p className="text-center">利用規約</p>
        <ul>
          <li>
            会員が本サービスを利用する際には、あらかじめ別途当社が提示するサポートメニューから本サービス利用者が適切と判断するチケットを選択し、購入し予約を行う必要があります。
          </li>
          <li>
            チケットを購入するには、当社が指定するクレジットカードが必要となります。なお、購入されたチケット代金は、当社に故意又は重過失がある場合を除き、返金することができませんので、あらかじめご了承ください。
          </li>
          <li>購入時に利用したクーポンの再利用は出来かねます。</li>
          <li>予約日時を過ぎたチケットは無効となり、ご利用いただけません。</li>
          <li>有償、無償を問わず他人への譲渡はできません。</li>
          <li>
            料金は予告なく変更になる場合があります。その際は差額が必要です。
          </li>
          <li>
            本サービスの利用には、当社所定の方法にて会員が本サービスを利用する希望する時間帯をあらかじめ予約する必要があります。
          </li>
          <li>
            会員の都合にて確定後の予約日時を変更する場合、予約した時間の30分前までであれば無条件に日時変更をすることができます。その場合、改めて希望する日時での予約を行ってください。
          </li>
          <li>
            会員が事前の予約変更をせずに予約した時間帯に遅れた場合、開始時間にかかわらず、当初予定していた時間にて、相談員が作業途中であっても本サービスの提供を終了いたします。その場合において会員が本サービスの継続を希望する場合、別途相談員が提案する「延長チケット」をその場でご購入ください。
          </li>
          <li>
            会員は任意で、予約する際に本サービスを提供する相談員を指名することができます。
          </li>
          <li>
            会員が予約した時間帯に当社の都合により指名した相談員が本サービスを提供できなかった場合、当社は代わりの相談員にて本サービスを提供いたします。但し、会員が代替相談員による本サービス提供に納得されない場合、本サービス提供開始時にその旨を告げることにより、
            当日の予約を無条件に予約日時の変更を行うことができます。なお、日時の変更については改めて会員にて行ってください。（返金等の手続きは行いません）
          </li>
          <li>
            チケット番号とは、予約を行った会員に対して、当該予約を証明するための当社が発行する識別番号です。
          </li>
          <li>
            本サービス利用者は、本サービス利用時に、チケット番号を相談員に通知していただきます。
          </li>
          <li>
            チケット番号は、本サービス利用者ご自身で厳重に管理し、みだりに第三者に教えたりしないようにしてください。
          </li>
          <li>
            チケット番号が第三者（他の会員などを含みます）に漏えいし、又は使用されたことにより当該本サービス利用者に何らかの損害が生じた場合でも、当社は当該本サービス利用者の故意過失にかかわらず一切責任を負わないものとします。
          </li>
          <li>
            本サービスの提供に伴い当社になされるすべての請求権に関する損害賠償の上限額は、当該本サービス利用者が支払われた本サービスのチケット代金を上限とします。
            <br />
            なお、当社は、当社・本サービス利用者及び第三者の予見の有無を問わず特別の事情から生じた損害・逸失利益・第三者からの請求による損害などのその他の損害について、一切賠償責任を負わないものとします。
          </li>
          <li>弊社ホームページ内に記載されている利用規約をお読みください</li>
        </ul>
        <div className="card-post-text">
          <p>
            支払いを確定すると、お客様は じぶん専用IT相談室
            が規約に従って今回の支払いをお客様のカードに請求し、支払い情報を保存することを許可したことになります。
          </p>
        </div>
        <div className="card-powered-by">
          <p>
            Powered by{" "}
            <a
              href="https://pay.jp/"
              target="_blank"
              style={{ color: "var(--text-color-3)" }}
            >
              Pay.jp
            </a>
          </p>
        </div>
      </div>
      <Typography
        style={{
          textAlign: "center",
          margin: "2rem 0 0",
          fontSize: "0.8rem",
          fontWeight: "600",
        }}
      >
        上記お申込内容、利用規約及び
        <a
          href="https://www.wons.co.jp/privacypolicy/"
          target="_blank"
          style={{ color: "#2683c3", borderBottom: "1px solid" }}
        >
          プライバシーポリシー
        </a>
        に同意し、支払いを確定するには下のボタンを押してください。
      </Typography>
      <div
        className="row"
        style={{
          textAlign: "center",
          paddingTop: "2rem",
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          width: "300px",
          maxWidth: "100%",
          margin: "0 auto",
        }}
      >
        {loading && <div className="button-overlay"></div>}
        <button
          onClick={(e) => handlePayjp(e, true)}
          className={
            buttonClickable
              ? ` classification-btn`
              : "classification-btn disable-btn"
          }
          disabled={buttonClickable == false || concernTextError == true}
        >
          <span>
            {loading ? <ButtonLoader btnColor={"light"} /> : "支払う"}
          </span>
        </button>
        <br />
        {!reserveNowParam && (
          <button
            className="secondary-btn"
            onClick={() => {
              ["INTERVIEW", "TIP", "ADD"].includes(productType)
                ? navigate("/")
                : navigate(`/support/staff?productId=${productId}`, {
                    state: {
                      ...JSON.parse(
                        sessionStorage.getItem("state") ??
                          JSON.stringify(productInfo)
                      ),
                    },
                  });
            }}
          >
            {["INTERVIEW", "TIP", "ADD"].includes(productType)
              ? "ホームに戻る"
              : "日時/相談員選択に戻る"}
          </button>
        )}

        {errorModal && error && (
          <ErrorModal
            errorModal={errorModal}
            setErrorModal={setErrorModal}
            message={error}
          />
        )}
      </div>
      <input
        type="hidden"
        id="payjp_public_key"
        value={Environment.getPayjpId()}
      />
    </section>
  );
}
